import RedeemView from 'src/sections/overview/redeem/view/redeem-view';

export default function Redeem() {
  return <RedeemView />;
}
